import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OutletBackgroundService {
  private backgroundImageSubject = new BehaviorSubject<string>('');
  backgroundImage$ = this.backgroundImageSubject.asObservable();

  setBackgroundImage(imageUrl: string): void {
    this.backgroundImageSubject.next(imageUrl);
  }

  clearBackgroundImage(): void {
    this.backgroundImageSubject.next('');
  }
}
